import React from 'react';
import { Link , withRouter} from "react-router-dom";
import './Footer.scss';
import jgawb from "./images/jgawb.png"
import party_government_organs from "./images/party_government_organs.png"


class Footer extends React.Component {
	constructor(props){
	    super(props);
	}

	state = {
		
	}

	componentDidMount(){
	}

	render() {
		return (
	      	<div className="footer">
	      		<div>
	      			<div>版权所有：国家市场监督管理总局</div>
	      			<div>
	      				网站标识码bm30000012    
	      				京ICP备18022388号            
	      				<img src={ jgawb } className="jgawb" />
	      				京公网安备 11010202008101号</div>
	      			<div>
	      				<span className="address">地址：北京市西城区三里河东路八号</span>
	      				邮政编码：100820
	      			</div>

	      		</div>
	      		<img src={ party_government_organs } className="party_government_organs" />
            </div>
		);
	}
}

// export default withRouter(Header);
export default Footer;
